import SettingsService from 'live/services/settings'
import AggregatorExecutorConfig from './settings/AggregatorExecutorConfig'
import AggregatorReportConfig from './settings/AggregatorReportConfig'
import AggregatorListenerConfig from './settings/AggregatorListenerConfig'
import AggregatorBaseConfig from './settings/AggregatorBaseConfig'

try {
    document.addEventListener('DOMContentLoaded', function() {
        require('./init')
    })
} catch (e) {}

SettingsService.register(AggregatorExecutorConfig)

SettingsService.register(AggregatorReportConfig)

SettingsService.register(AggregatorListenerConfig)

SettingsService.register(AggregatorBaseConfig)

require('./components')

